import faviconLocal from "assets/img/favicon/favicon-local-32x32.png"
import faviconDev from "assets/img/favicon/favicon-dev-32x32.png"
import faviconTst from "assets/img/favicon/favicon-tst-32x32.png"
import faviconTst2 from "assets/img/favicon/favicon-tst2-32x32.png"
import faviconTest from "assets/img/favicon/favicon-test-32x32.png"

import { useEffect } from "react"

import env, { Environment } from "utils/env"

// environment-specific indicators
export default function useEnvIndicators() {
    useEffect(() => {
        const iconPath = getEnvIconPath(env);
        if (iconPath.length > 0) {
            document.querySelector('link[rel="icon"]')?.setAttribute('href', iconPath)
        }
    }, [])

    function getEnvIconPath(environment: Environment) {
        switch (environment) {
            case Environment.local:
                return faviconLocal;
            case Environment.dev:
                return faviconDev
            case Environment.test:
                return faviconTst
            case Environment.test2:
                return faviconTst2
            case Environment.staging:
                return faviconTest
            default:
                return "";
        }
    }
}
